import React from 'react';
import ReactDOM from 'react-dom/client';
import Cookies from 'js-cookie';
// import { BrowserRouter } from 'react-router-dom';  // Import BrowserRouter
import App from './App';  // Import App component
import './index.css';
import reportWebVitals from './reportWebVitals';

const savedLanguage = Cookies.get('language');
document.documentElement.lang =
  savedLanguage === 'ku' || savedLanguage === 'ar' ? savedLanguage : 'en';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    {/* <BrowserRouter>  */}
      <App />
    {/* </BrowserRouter> */}
  </React.StrictMode>
);

reportWebVitals();
